/*
 * @Author: Mike Cottingham 
 * @Date: 2018-04-24 20:30:23 
 * @Last Modified by: Mike Cottingham
 * @Last Modified time: 2018-04-25 12:43:20
 */

import core from "../core"
import { GET_APPOINTMENTS } from "../../service/query"
import { $authHost } from "service/indexApi"

export default class Service {
  search({loading, search, ...query}, authToken = undefined) {
    const {firstName, lastName, minDate, maxDate} = query

    const variables = {
      params: {
        firstName: firstName || null,
        lastName: lastName || null,
        maxDate,
        minDate
      }
    }
    return $authHost.post(`${process.env.REACT_APP_BASE_URL}/graphql`, {
        query: GET_APPOINTMENTS,
        variables
      }).then(({data: {data: {appointments}}}) => appointments)
  }
}